const AtmLocatorIcon = () => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.2031 24.7188H5.79688C4.43773 24.7188 3.33594 25.8205 3.33594 27.1797C3.33594 27.6327 3.70322 28 4.15625 28H23.8438C24.2968 28 24.6641 27.6327 24.6641 27.1797C24.6641 25.8205 23.5623 24.7188 22.2031 24.7188Z"
        fill="#606062"
      />
      <path
        d="M20.5625 0H7.4375C6.08048 0 4.97656 1.15861 4.97656 2.51562V14.8203C8.57784 14.8203 19.3935 14.8203 23.0234 14.8203V2.51562C23.0234 1.15861 21.9195 0 20.5625 0ZM14 13.1797H9.07812C8.62471 13.1797 8.25781 12.8128 8.25781 12.3594C8.25781 11.906 8.62471 11.5391 9.07812 11.5391H14C14.4534 11.5391 14.8203 11.906 14.8203 12.3594C14.8203 12.8128 14.4534 13.1797 14 13.1797ZM14.8203 9.07812C14.8203 9.53154 14.4534 9.89844 14 9.89844H9.07812C8.62471 9.89844 8.25781 9.53154 8.25781 9.07812V4.15625C8.25781 3.70284 8.62471 3.33594 9.07812 3.33594H14C14.4534 3.33594 14.8203 3.70284 14.8203 4.15625V9.07812ZM18.9219 13.1797C18.4688 13.1797 18.1016 12.8124 18.1016 12.3594C18.1016 11.9063 18.4688 11.5391 18.9219 11.5391C19.3749 11.5391 19.7422 11.9063 19.7422 12.3594C19.7422 12.8124 19.3749 13.1797 18.9219 13.1797ZM18.9219 8.25781H17.2812C16.8278 8.25781 16.4609 7.89091 16.4609 7.4375C16.4609 6.98409 16.8278 6.61719 17.2812 6.61719H18.9219C19.3753 6.61719 19.7422 6.98409 19.7422 7.4375C19.7422 7.89091 19.3753 8.25781 18.9219 8.25781ZM18.9219 4.97656H17.2812C16.8278 4.97656 16.4609 4.60966 16.4609 4.15625C16.4609 3.70284 16.8278 3.33594 17.2812 3.33594H18.9219C19.3753 3.33594 19.7422 3.70284 19.7422 4.15625C19.7422 4.60966 19.3753 4.97656 18.9219 4.97656Z"
        fill="#606062"
      />
      <path
        d="M4.97656 16.4609V23.0781H23.0234V16.4609C19.3876 16.4609 8.57686 16.4609 4.97656 16.4609Z"
        fill="#606062"
      />
    </svg>
  );
};

export default AtmLocatorIcon;
